import {
  withTranslation,
} from 'react-i18next';

import RegattaContactFieldsView from './RegattaContactFieldsView';

const TranslatedComponent = withTranslation()(RegattaContactFieldsView);

const Component = TranslatedComponent;

export default Component;
